import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

const Card = styled.div`
  padding: 1rem;
  border-radius: 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  transition: border 0.3s ease;
  
  ${props => props.isHighlighted && `
    border: 3px solid #5ce9ff;
    box-shadow: 0 0 15px rgba(92, 233, 255, 0.3);
  `}
`;

const Label = styled.span`
  color: white;
  font-size: 1rem;
  font-weight: 500;
  ${props => props.isHighlighted && `
    padding-left: 1.5rem;
  `}
`;

const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const Price = styled.span`
  color: white;
  font-size: 1rem;
  font-weight: 500;
`;

const BidCountContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: 1rem;
  color: #5ce9ff;
  font-size: 0.875rem;
`;

const BidIcon = styled.svg`
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  flex-shrink: 0;
`;

const PulsingDot = styled.div`
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #5ce9ff;
  box-shadow: 0 0 0 0 rgba(92, 233, 255, 1);
  animation: pulse 2s infinite;
  
  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(92, 233, 255, 0.7);
    }
    70% {
      box-shadow: 0 0 0 10px rgba(92, 233, 255, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(92, 233, 255, 0);
    }
  }
`;

const AggregateQuantity = styled.div`
  color: #5ce9ff;
  font-size: 0.875rem;
  font-weight: 600;
  margin-top: 0.25rem;
`;

const TierCard = ({ 
  tier, 
  symbol, 
  bidCount = 0,
  showBidCount = true,
  isHighlighted = false,
  aggregateQuantity = null
}) => {
  return (
    <Card isHighlighted={isHighlighted}>
      {isHighlighted && <PulsingDot />}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Label isHighlighted={isHighlighted}>{tier.minQty || tier.qty} units</Label>
        {isHighlighted && aggregateQuantity !== null && (
          <AggregateQuantity>
            Aggregate quantity: {aggregateQuantity}
          </AggregateQuantity>
        )}
      </div>
      <PriceContainer>
        <Price>
          {symbol ? `${symbol} ` : ''}{tier.price} / unit
        </Price>
        {showBidCount && bidCount > 0 && (
          <BidCountContainer>
            <BidIcon viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
            </BidIcon>
            <span>{bidCount} {bidCount === 1 ? 'bid' : 'bids'}</span>
          </BidCountContainer>
        )}
      </PriceContainer>
    </Card>
  );
};

const TiersContainer = ({ children }) => (
  <Container>{children}</Container>
);

TiersContainer.Tier = TierCard;

export default TiersContainer;

